<template>
  <toast v-model="showToast" v-if="showToast" :msg="msg"></toast>
</template>
<script>
/* eslint-disable */
import Toast from '@/components/Toast'
import { fetchHouse, fetchFavirote, doFavirote } from '@/services/house.js'
import { errorReport } from '@/utils/index.js'
import Cookies from 'js-cookie'
import tujialogin from '@/utils/tujialogin.js'
import { base64Encode } from '@/utils/base64'
import { mpUtils } from '@tujia/fe-lib-bridge'

const u = navigator.userAgent
const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

export default {
  mixins: [tujialogin],
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      showToast: false,
      msg: 'hello world'
    }
  },
  watch: {
    payLoad(newVal) {
      // eslint-disable-next-line
      if (newVal && newVal.type === 'openHouseInfo') {
        this.showHouseInfo(newVal.data)
      } else if (newVal && newVal.type === 'favoriteHouse') {
        this.doFavorite(newVal.data)
      }
    }
  },
  mounted() {
    // this.initHouses()
  },
  methods: {
    /**
     * 跳转房屋详情
     * @param {Number} unitId 房屋id
     * @param {String} startDate 开始时间
     * @param {String} endDate 结束时间
     */
    async showHouseInfo(unitId) {
      let monent = require('moment')
      let startDate = this.compProps.fromDate || moment().format('YYYY-MM-DD')
      let endDate = this.compProps.toDate || moment().add('days',1).format('YYYY-MM-DD')
      const { code = `cms_${this.$root.promotionId}` } = this.$route.query
      try {
        // 这个埋点方案不是很好。想想以后改进一下。其他地方同。
        if (window._vds && window._vds.track) {
          window._vds.track(`${this.$root.isMobile ? 'H5' : 'PC'}_houseid_cms`, {
            [`${this.$root.isMobile ? 'H5' : 'PC'}_houseid_cms_bian`]: unitId,
            'activityid_cms': this.$root.promotionId
          })
        }
        let atmQuery = ''
        if (this.$root.atm_source) {
          atmQuery = `&atm_source=${this.$root.atm_source}`
        }
        // 正常情况下需要传递日期给后端，但是该页面为配置页面，没有具体业务。所以需要后端接口抹平
        const platform = await this.getEnv()
        if (this.platformEnv.isMpEnv) {
          const h5url = `https://m.tujia.com/detail/${unitId}.htm?beginDate=${startDate}&endDate=${endDate}${atmQuery}&code=${code}&tjchannelid=${this.tjChannelId}&dg=1`
          const wxUrl = this.tjChannelId === channelTypes.ELONG ? `/page/home/webview/webview?src=${encodeURIComponent(wrapAuthorizeUrl(h5url))}` : `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(h5url)}`
          mpUtils.navigateTo({
            url: wxUrl
          })
        } else {
          if (platform === 2) {
            // 跳转客户端房屋详情
            window.location.href = `https://app.tujia.com/go/unitdetail?id=${unitId}&start=${startDate}&end=${endDate}&isFromPromotion=true${atmQuery}`
          } else if (platform === 1 && this.tjChannelId === 'tujia') {
            // 跳转小程序房屋详情
            // eslint-disable-next-line
            wx.miniProgram.navigateTo({
              url: `/pages/unitDetails_v2/unitDetails?unitId=${unitId}&beginDate=${startDate}&endDate=${endDate}${atmQuery}`
            })
          } if (platform === 9) {
            // 携程详情页
            let url = `/rn_bnb_order/main.js?CRNType=1&CRNModuleName=TuJiaApp&initialPage=ProductPage&houseId=${unitId}&checkin=${startDate}&checkout=${endDate}`
            window.location.href = `ctrip://wireless/h5?url=${base64Encode(url)}&type=5`
          } if (platform === 10) {
            // 跳转去哪详情页
            const url = `qunarphone://react/open?hybridId=tj_product_detail_rn&pageName=ProductPage&initProps=${encodeURIComponent(JSON.stringify({ param: { houseId: `${unitId}` } }))}`
            window.location.href = url;
          } else {
            // 移动端浏览器跳转房屋详情
            if (this.$root.isMobile) {
              Cookies.set(`${process.env.VUE_APP_TUJIA_DOMAIN}_MobileContext_StartDate`, startDate, { domain: process.env.VUE_APP_TUJIA_DOMAIN })
              Cookies.set(`${process.env.VUE_APP_TUJIA_DOMAIN}_MobileContext_EndDate`, endDate, { domain: process.env.VUE_APP_TUJIA_DOMAIN })
              window.location.href = `${this.mTujiaHost}/detail/${unitId}.htm?dg=1`
            } else {
              window.location.href = `${this.pcTujiaHost}/detail/${unitId}.htm?startDate=${startDate}&endDate=${endDate}${atmQuery}`
            }
          }
        }
      } catch (e) {
        errorReport(e)
      }
    },
    /**
     * 收藏
     * @param {Object} house 房屋
     */
    async doFavorite(house) {
      try {
        const ret = await doFavirote(house.id, house.isLike)
        if (ret && ret.errcode === 0) {
          this.$emit('finish', { type: 'favirote', data: { id: house.id, isLike: !house.isLike } })
        } else if (ret && ret.errcode === 55004) {
          this.goLoginPage()
        }
      } catch (e) {
        this.msg = '系统开小差了，一会再试试吧'
        this.showToast = true
        errorReport(e)
      }
    },
    openScheme(url) {
      if (Sniff.qunar) {
        const hysdk = window.hysdk
        hysdk && hysdk.openWebView({ url, type: 'navibar-none' })
      } else {
        // const scheme = Sniff.ios ? 'qunariphone' : 'qunaraphone'
        const scheme = 'qunarphone'
        const schemeUrl = `${scheme}://hy?url=${encodeURIComponent(
          url
        )}&type=navibar-none`
        window.location.href = schemeUrl
        window.setTimeout(() => {
          window.location.href = url
        }, 500)
      }
    }
  }
}
</script>
